// extracted by mini-css-extract-plugin
module.exports = {"Cards":"Cards_Cards__2LXaI","userCards":"Cards_userCards__2NmBb"};